module.exports = __webpack_public_path__ + "img/魔方.182e961d.png";